import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-what-to-know-sh',
  imports: [TranslateModule],
  templateUrl: './what-to-know-sh.component.html',
  styleUrl: './what-to-know-sh.component.scss'
})
export class WhatToKnowShComponent {

}
